import React, { Fragment, useState } from 'react';
import { Button, Select, Input, Form } from 'antd';

import ColorPicker from '../../components/ColorPicker';

const { Option } = Select;
const { Item } = Form;

const ASSET_TYPES = [
    { label: 'Blockchain', value: 'blockchain' },
    { label: 'Fiat', value: 'fiat' },
    { label: 'Other', value: 'other' }
];

const EditAsset = ({
    type = "color",
    coinFormData = {},
    handleChange,
    handleSelectChange,
    handleMetaChange,
    onClose,
    form
}) => {
    const { meta = {} } = coinFormData;
    const [assetType, setType] = useState(coinFormData.type);

    const { getFieldDecorator } = form;

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err) => {
            if (!err) {
                onClose();
            }
        });
    };

    const renderItems = () => {
        if (type === 'color') {
            return (
                <div className="md-field-wrap">
                    <span className="sub-title">Color</span>{' '}<span className='sub-text'>(HEX Value):</span>
                    <ColorPicker
                        value={meta.color}
                        onChange={(val) => handleMetaChange(val, 'color')}
                    />
                </div>
            );
        } else {
            return (
                <Fragment>
                    {!coinFormData.verified
                        ? <Fragment>
                            <div className="md-field-wrap">
                                <div className="sub-title">Type</div>
                                <Select
                                    name={'type'}
                                    value={assetType}
                                    onChange={(value) => {
                                        handleSelectChange(value, 'type');
                                        setType(value);
                                    }}
                                >
                                    {ASSET_TYPES.map((type, index) => (
                                        <Option key={index} value={type.value}>{type.label}</Option>
                                    ))}
                                </Select>
                            </div>
                            <div className="md-field-wrap">
                                <div className="sub-title">Asset symbol</div>
                                <Item>
                                    {getFieldDecorator("symbol", {
                                        initialValue: coinFormData.symbol,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'This field is required!'
                                            },
                                            {
                                                max: 5,
                                                message: 'Username must be maximum 5 characters.'
                                            },
                                            {
                                                min: 2,
                                                message: 'Username must be minimum 2 characters.'
                                            }
                                        ]
                                    })(
                                        <Input
                                            name="symbol"
                                            placeholder="Enter short hand name"
                                            onChange={handleChange}
                                        />
                                    )}
                                </Item>
                            </div>
                        </Fragment>
                        : null
                    }
                    <div className="md-field-wrap">
                        <div className="sub-title">Asset name</div>
                        <Item>
                            {getFieldDecorator("fullname", {
                                initialValue: coinFormData.fullname,
                                rules: [
                                    {
                                        required: true,
                                        message: 'This field is required!'
                                    }
                                ],
                            })(
                                <Input
                                    name="fullname"
                                    placeholder="Enter long form name"
                                    onChange={handleChange}
                                />
                            )}
                        </Item>
                    </div>
                    {assetType === 'vault'
                        ? <div className="md-field-wrap">
                            <div className="sub-title">Contract</div>
                            <Input
                                name={'contract'}
                                placeholder={'Enter short hand name'}
                                value={coinFormData.contract}
                                onChange={handleChange}
                            />
                        </div>
                        : null
                    }
                </Fragment>
            );
        }
    };

    return (
        <div>
            <div className="title">Edit Asset</div>
            <Form onSubmit={handleSubmit}>
                <div className="edit-wrap">
                    {renderItems()}
                </div>
                <div className="btn-wrapper">
                    <Button type="primary" onClick={onClose}>
                        Back
                    </Button>
                    <div className="separator"></div>
                    <Button type="primary" htmlType="submit">
                        Confirm
                    </Button>
                </div>
            </Form>
        </div>
    );
}

export default Form.create({ name: 'EditAssetName' })(EditAsset);
